import { Artwork } from "@/models/artwork.model";
import { Gallery } from "@/models/gallery.model";
import User from "@/models/user.model";

import * as AdminActions from './admin.actions';
import { SpaceData } from "@/types/spaceData";

export interface State {
    users: User[];
    galleries: Gallery[];
    systemId: string;
    defaultSpaceId: string;
    loading: boolean;
    adminError: string | null;
    artworks: Artwork[];
    spaces: SpaceData[];
}

const initialState: State = {
    systemId: "",
    defaultSpaceId: "",
    users: [],
    artworks: [],
    galleries: [],
    spaces: [],
    loading: false,
    adminError: null
}

export function adminReducer(state = initialState, action: {type: string, payload: any}) {
    let newGalleries = []
    let spaces = []
    switch (action.type) {
        case AdminActions.DELETE_GALLERY:
            return {
                ...state,
                loading: true,
                adminError: null
            }
        case AdminActions.DELETE_GALLERY_SUCCESS:
            return {
                ...state,
                loading: false,
                adminError: null,
                galleries: state.galleries.filter(g => g._id !== action.payload)
            }
        case AdminActions.DELETE_GALLERY_FAILED:
            return {
                ...state,
                loading: false,
                adminError: action.payload
            }
        case AdminActions.CREATE_ARTWORK:
            return {
                ...state,
                loading: true,
                adminError: null
            }
        case AdminActions.CREATE_ARTWORK_SUCCESS:
            return {
                ...state,
                loading: false,
                artworks: [...state.artworks, action.payload]
            }
        case AdminActions.CREATE_ARTWORK_FAILED:
            return {
                ...state,
                loading: false,
                adminError: action.payload
            }
        case AdminActions.UPDATE_ARTWORK:
            return {
                ...state,
                loading: true,
                adminError: null
            }
        case AdminActions.UPDATE_ARTWORK_SUCCESS:
            let artworks = [];
            artworks = state.artworks.map(a => a._id === action.payload._id ? action.payload : a);
        return {
                ...state,
                loading: false,
                artworks
            }
        case AdminActions.GET_ARTWORKS:
            return {
                ...state,
                loading: true,
                adminError: null
            }
        case AdminActions.GET_ARTWORKS_SUCCESS:
            return {
                ...state,
                loading: false,
                artworks: action.payload
            }
        case AdminActions.GET_ARTWORKS_FAILED:
            return {
                ...state,
                loading: false,
                adminError: action.payload
            }
        case AdminActions.CREATE_GALLERY:
            return {
                ...state,
                loading: true,
                adminError: null
            }
        case AdminActions.CREATE_GALLERY_SUCCESS:
            newGalleries = state.galleries.map(g => g)
            return {
                ...state,
                loading: false,
                adminError: null,
                galleries: [...newGalleries, action.payload]
            }
        case AdminActions.CREATE_GALLERY_FAILED:
            return {
                ...state,
                loading: false,
                adminError: action.payload
            }
        case AdminActions.UPDATE_GALLERY:
            return {
                ...state,
                loading: true,
                adminError: null
            }
        case AdminActions.UPDATE_GALLERY_SUCCESS:
            newGalleries = state.galleries.map(g => g._id === action.payload._id ? action.payload : g)
            return {
                ...state,
                loading: false,
                adminError: null,
                galleries: newGalleries
            }
        case AdminActions.UPDATE_GALLERY_FAILED:
            return {
                ...state,
                loading: false,
                adminError: action.payload
            }
        case AdminActions.GET_GALLERIES:
            return {
                ...state,
                loading: true,
                adminError: null
            }
        case AdminActions.GET_GALLERIES_SUCCESS:
            return {
                ...state,
                loading: false,
                galleries: action.payload.galleries,
                spaces: action.payload.spaces ?? state.spaces,
                artworks: action.payload.artworks ?? state.artworks
            }
        case AdminActions.GET_GALLERIES_FAILED:
            return {
                ...state,
                loading: false,
                adminError: action.payload
            }
        case AdminActions.GET_DEFAULT_SPACE:
            return {
                ...state,
                loading: true,
                adminError: null
            }
        case AdminActions.GET_DEFAULT_SPACE_SUCCESS: 
            return {
                ...state,
                loading: false,
                adminError: null,
                systemId: action.payload.systemId
            }
        case AdminActions.GET_DEFAULT_SPACE_FAILED:
            return {
                ...state,
                loading: false,
                adminError: action.payload
            }
        case AdminActions.GET_USERS: 
            return {
                ...state,
                loading: true,
                adminError: null
            }
        case AdminActions.GET_USERS_SUCCESS:
            return {
                ...state,
                loading: false,
                adminError: null,
                users: action.payload
            }
        case AdminActions.GET_USERS_FAILED:
            return {
                ...state,
                loading: false,
                adminError: action.payload,
                users: []
            }
        case AdminActions.GET_SPACES:
            return {
                ...state,
                loading: true,
                adminError: null
            }
        case AdminActions.GET_SPACES_SUCCESS:
            return {
                ...state,
                loading: false,
                adminError: null,
                spaces: action.payload
            }
        case AdminActions.GET_SPACES_FAILED:
            return {
                ...state,
                loading: false,
                adminError: action.payload
            }
        case AdminActions.ASSIGN_MOOD_TO_USER:
            return {
                ...state,
                loading: true,
                adminError: null
            }
        case AdminActions.ASSIGN_MOOD_TO_USER_SUCCESS:
            spaces = state.spaces.map(s => s._id === action.payload._id ? action.payload : s);
            return {
                ...state,
                loading: false,
                adminError: null,
                spaces
            }
        case AdminActions.ASSIGN_MOOD_TO_USER_FAILED:
            return {
                ...state,
                loading: false,
                adminError: action.payload
            }
        case AdminActions.UNASSIGN_MOOD_FROM_USER:
            return {
                ...state,
                loading: true,
                adminError: null
            }
        case AdminActions.UNASSIGN_MOOD_FROM_USER_SUCCESS:
            spaces = state.spaces.map(s => s._id === action.payload._id ? action.payload : s);
            return {
                ...state,
                loading: false,
                adminError: null,
                spaces
            }
        case AdminActions.UNASSIGN_MOOD_FROM_USER_FAILED:
            return {
                ...state,
                loading: false,
                adminError: action.payload
            }
        default: 
            return {
                ...state
            }
    }
}
